/** make sure parent component has "group" as classname */
export const Tooltip = ({ message }: { message: string }) => {
  return (
    <>
      <span className="bg-black text-sm text-offwhite p-3 pr-5 rounded-lg top-3/4 z-10 left-2.5 w-auto hidden group-hover:inline absolute">
        <span
          className="absolute border-solid -top-4 left-7"
          style={{
            borderColor: 'transparent transparent black transparent',
            borderWidth: 10,
          }}
        ></span>
        {message}
      </span>
    </>
  );
};
